"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoomsCountSelector = RoomsCountSelector;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _uiKit = require("@cian/ui-kit");
var _ErrorPopover = require("../../../ErrorPopover");
var styles = _interopRequireWildcard(require("./styles.css"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RoomsCountSelector(props) {
  const {
    errorMessage,
    value,
    className,
    onValueChange,
    values
  } = props;
  const valuesList = React.useMemo(() => (0, _utils.sortRoomsCount)(Object.values(values)), [values]);
  return /*#__PURE__*/React.createElement(_uiKit.UiKitRoot, {
    deviceType: "phone",
    useStaticDeviceType: true
  }, /*#__PURE__*/React.createElement(_ErrorPopover.ErrorPopover, {
    tooltipContent: errorMessage || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['container'], className),
    "data-name": "roomsCount_filter"
  }, /*#__PURE__*/React.createElement(_uiKit.RadioButtonGroup, {
    value: value || undefined,
    options: valuesList,
    onChange: (_, value) => onValueChange(value)
  }))));
}